module.exports = __webpack_public_path__ + "images/13b83ffb477fcc06592501ddf63c6801b77459a22ec3a73b9bd561eb96078e24.svg";